import { render } from "./ChangePage.vue?vue&type=template&id=fcc604d2"
import script from "./ChangePage.vue?vue&type=script&lang=js"
export * from "./ChangePage.vue?vue&type=script&lang=js"

import "./ChangePage.vue?vue&type=style&index=0&id=fcc604d2&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__